import { createContext, useContext } from 'react';
import type { PedirCodigo } from '../api/dosPasosEnElMomento';

/** Pide el código de dos pasos en el momento con la ventana de `ProveedorDosPasos` (G116). */
export const ContextoDosPasos = createContext<PedirCodigo>(() => Promise.resolve(null));

export function usePedirCodigoDosPasos(): PedirCodigo {
    return useContext(ContextoDosPasos);
}
